import API from '@aws-amplify/api'

import configurator, { API_GATEWAY_NAME } from './configurator'
import applicationConfig from '../config'

configurator(API, applicationConfig)

export default {
  API_GATEWAY_NAME,
  API,
}
